"use client";

import React from "react";
var __jsx = React.createElement;
import { ThemeProvider } from "@mui/material";
import { QueryClient, QueryClientProvider, HydrationBoundary } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { LoadingResourcesProvider } from "@lib/context/shared/loading-resources-context";
import MuscleMuiTheme from "@lib/mui-theme";
import { CustomerProvider } from "@lib/context/shared/customer-context";
import { NotificationsProvider } from "@lib/context/shared/notifications-context";
import { NextIntlClientProvider } from "next-intl";
import { LanguageConfigProvider } from "@lib/context/shared/lang-context";
import { ModalMessagesProvider } from "@lib/context/shared/modal-message-context";
import { ErrorPageProvider } from "@lib/context/shared/errors-context";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Hotjar from "@hotjar/browser";
import { ActiveContentProvider } from "@lib/context/shared/active-content-context";
import { BenefitIframeProvider } from "@lib/context/shared/benefit-iframe-context";
import { CancellationsProvider } from "@lib/context/shared/cancellations-context";
import { OffersProvider } from "@modules/offers/context/offers-context";
import { SidePanelStackProvider } from "@modules/shared/components/side-over-panel";
import { SidePanelProvider } from "@modules/mobile/hooks/useSideOverPanel";
import identifyHotjarUser from "@lib/hotjar";
import { ForwardNodeProvider } from "@modules/mobile/hooks/useForwardNode";
import { MobileFiltersProvider } from "@lib/context/mobile/filters-context";
import CarsProviders from "./cars";
function makeQueryClient() {
  return new QueryClient();
}
let clientQueryClient = undefined;
function getQueryClient() {
  if (typeof window === "undefined") {
    // Server: always make a new query client
    return makeQueryClient();
  } else {
    // Browser: make a new query client if we don't already have one
    if (!clientQueryClient) clientQueryClient = makeQueryClient();
    return clientQueryClient;
  }
}
export function hotJarInitialization() {
  var _parseInt;
  const siteId = (_parseInt = parseInt(process.env.NEXT_PUBLIC_HOTJAR_ID || "0")) !== null && _parseInt !== void 0 ? _parseInt : 4932739;
  const hotjarVersion = 6;
  Hotjar.init(siteId, hotjarVersion);
  identifyHotjarUser();
}
export default function SharedProviders(_ref) {
  let {
    children,
    locale,
    messages,
    dehydratedState
  } = _ref;
  const queryClient = getQueryClient();
  hotJarInitialization();
  return __jsx(NextIntlClientProvider, {
    locale: locale,
    messages: messages,
    timeZone: "UTC"
  }, __jsx(ThemeProvider, {
    theme: MuscleMuiTheme
  }, __jsx(QueryClientProvider, {
    client: queryClient
  }, __jsx(HydrationBoundary, {
    state: dehydratedState
  }, __jsx(LocalizationProvider, {
    dateAdapter: AdapterDayjs
  }, __jsx(LanguageConfigProvider, {
    locale: locale
  }, __jsx(LoadingResourcesProvider, null, __jsx(OffersProvider, null, __jsx(CancellationsProvider, null, __jsx(ModalMessagesProvider, null, __jsx(NotificationsProvider, null, __jsx(ActiveContentProvider, null, __jsx(ErrorPageProvider, null, __jsx(CustomerProvider, null, __jsx(BenefitIframeProvider, null, __jsx(ForwardNodeProvider, null, __jsx(SidePanelProvider, null, __jsx(MobileFiltersProvider, null, __jsx(CarsProviders, null, __jsx(SidePanelStackProvider, null, children))))))))))))))))), __jsx(ReactQueryDevtools, {
    initialIsOpen: false
  }))));
}